import { isBoolean } from 'lodash';
import React from 'react';

import Generic from './Generic';

interface BooleanProps extends React.HTMLAttributes<HTMLDivElement> {
  value: boolean | null | undefined;
}

const BooleanCell: React.FC<BooleanProps> = ({ value, ...props }) => {
  const displayValue = isBoolean(value) ? (value ? 'Yes' : 'No') : value;
  return <Generic value={displayValue} align="left" {...props} />;
};

export default BooleanCell;
